/* eslint-disable @typescript-eslint/no-unused-vars */
import { AutocompleteWithLabel } from '@adotel/components'
import { useQuery } from '@apollo/client'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Modal,
  Slide,
  Paper
} from '@material-ui/core'
import momentJalaali from 'moment-jalaali'
import React, { useRef, useState } from 'react'

import TimePeriodForm from '../../../components/TimePeriodForm'
import { PAYMENT_TERMS_QUERY } from '../../../graphql/walletPaymentTerm'
import {
  DateObject,
  gregorianToJalaali,
  jalaaliToGregorian
} from '../../../helpers/date'
import { getDirection, getTranslate, lang } from '../../../localization'
import { PaymentTermBrief } from '../../../types/walletPaymentTerm'
import useStyles from './styles/AddPaymentTermAssignment.styles'

interface AddPaymentTermModalProps {
  open: boolean
  onClose: () => void
  onSubmit: (
    paymentTermName: string,
    paymentTermCode: string,
    paymentTermID: string,
    from: string,
    to: string
  ) => void
  startDate: string
  disableAfter: string
}

const AddPaymentTermModal: React.FC<AddPaymentTermModalProps> = ({
  open,
  onClose,
  onSubmit,
  startDate,
  disableAfter
}) => {
  const classes = useStyles()
  const [onDoneClickForCloseDatePicker, setOnDoneClickForCloseDatePicker] =
    useState<boolean>(true)
  const coveringDatePickerRef = useRef<HTMLDivElement | null>(null)
  const [coveringRange, setcoveringRange] = useState<DateObject>({
    gregorianStartDate: startDate,
    jalaaliStartDate: gregorianToJalaali(startDate)
  })

  const [paymentTermAutoCompleteLabel, setpaymentTermAutoCompleteLabel] =
    useState<any>()
  const { data: paymentTerms, loading: loadingForPaymentTerms } = useQuery<{
    paymentTerms: PaymentTermBrief[]
  }>(PAYMENT_TERMS_QUERY, {
    notifyOnNetworkStatusChange: true
  })
  const handleClose = () => {
    setpaymentTermAutoCompleteLabel(null) // Reset payment term selection
    setcoveringRange({
      gregorianStartDate: startDate,
      jalaaliStartDate: gregorianToJalaali(startDate)
    }) // Reset date range
    setOnDoneClickForCloseDatePicker(true) // Reset the date picker state
    onClose() // Call the parent onClose function
  }
  return (
    <Modal
      open={open}
      dir={getDirection()}
      onClose={handleClose} // Use the new function here
      className={classes.root}>
      <Slide direction="down" in={open}>
        <Paper className={classes.deletePaper}>
          <div>
            <div className={classes.title}>
              {getTranslate('Add Payment Term')}
            </div>
            <div className={classes.content}>
              <AutocompleteWithLabel
                options={
                  !paymentTerms
                    ? []
                    : paymentTerms.paymentTerms.map((paymentTerm) => ({
                        label: paymentTerm.name,
                        value: paymentTerm.paymentTermID.toString(),
                        code: paymentTerm.paymentTermCode,
                        id: paymentTerm.paymentTermID.toString()
                      }))
                }
                inputSize="small"
                getOptionLabel={(option) => option.label}
                getOptionSelected={(option, value) =>
                  option.label
                    .toLowerCase()
                    .includes(value.label.toLowerCase()) === true
                }
                value={paymentTermAutoCompleteLabel}
                onChange={(_, value: any) => {
                  setpaymentTermAutoCompleteLabel({
                    value: value?.value,
                    label: value?.label,
                    code: value?.code,
                    id: value?.id
                  })
                }}
                label={getTranslate('Payment Term')}
                loading={loadingForPaymentTerms}
                loadingText={getTranslate('Loading') + '...'}
              />
              <div
                className={classes.datePickerContainer}
                ref={coveringDatePickerRef}>
                <Typography>{getTranslate('Date')}</Typography>
                <TimePeriodForm
                  isOpen={true}
                  dateObject={coveringRange}
                  onChange={(data: DateObject) => {
                    setcoveringRange(data)
                  }}
                  onDoneClickForCloseDatePicker={onDoneClickForCloseDatePicker}
                  setOnDoneClickForCloseDatePicker={
                    setOnDoneClickForCloseDatePicker
                  }
                  endDateCanBeSelectAsStartDate
                  fixedStart
                  enablePastDays={undefined}
                  // enableAllDays
                  hideFooterButtons
                  disableBefore={
                    lang === 'en' ? startDate : gregorianToJalaali(startDate)
                  }
                  disableAfter={
                    lang === 'en'
                      ? disableAfter
                      : gregorianToJalaali(disableAfter)
                  }
                />
              </div>
            </div>
            <DialogActions>
              <Button onClick={onClose} color="primary">
                {getTranslate('Cancel')}
              </Button>
              <Button
                onClick={() => {
                  onSubmit(
                    paymentTermAutoCompleteLabel.label,
                    paymentTermAutoCompleteLabel.code,
                    paymentTermAutoCompleteLabel.id,
                    coveringRange.gregorianStartDate || '',
                    coveringRange.gregorianEndDate || ''
                  )
                  setpaymentTermAutoCompleteLabel(null) // Reset payment term selection
                  // setcoveringRange({
                  //   gregorianStartDate: momentJalaali(
                  //     coveringRange.gregorianEndDate,
                  //     'YYYY-MM-DD'
                  //   )
                  //     .add(1, 'days')
                  //     .format('YYYY-MM-DD')
                  // }) // Reset date range
                  setOnDoneClickForCloseDatePicker(true) // Reset the date picker state
                  onClose() // Call the parent onClose function
                }}
                disabled={
                  !paymentTermAutoCompleteLabel ||
                  !coveringRange.gregorianStartDate ||
                  !coveringRange.gregorianEndDate
                }
                color="primary"
                variant="contained">
                {getTranslate('Add')}
              </Button>
            </DialogActions>
          </div>
        </Paper>
      </Slide>
    </Modal>
  )
}

export default AddPaymentTermModal
